module.exports = __webpack_public_path__ + "static/media/javascript-classes.b427b792.jpg";